import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { STATUS } from 'pages/views/devices/socketClient/types';
import { APP_NAME } from 'pages/views/devices/utils/helper';

const useGetCfd = () => {
  const cfdConnectionStatus = useSelector(state => state.hub.connection.browserCFD);
  const isBrowserCFDConnected = cfdConnectionStatus === STATUS.CONNECTED;
  const selectedDisplay = useSelector(state => state.hub.selectedDisplay);
  const isDisplaySelected = !isEmpty(selectedDisplay);
  const isCfdConnected = isDisplaySelected;
  const connectionMethodCopy = isBrowserCFDConnected ? 'browser window' : APP_NAME;
  const cfdInfo =
    isDisplaySelected && isCfdConnected ? (
      <span className="notranslate">
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'size' does not exist on type '{ id?: num... Remove this comment to see the full error message */}
        {selectedDisplay.size.width} x {selectedDisplay.size.height}
      </span>
    ) : (
      'No device connected'
    );

  return {
    cfdConnectionStatus,
    cfdInfo,
    isCfdConnected,
    isBrowserCFDConnected,
    connectionMethodCopy,
  };
};

export { useGetCfd };
